export default "__VITE_ASSET__b2897ac7__"